(function(){
  var cfg = window.AGEGATE_CFG || { rememberDays: 30, underageUrl: "" };
  function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }
  cfg.rememberDays = clamp(parseInt(cfg.rememberDays || 30, 10), 1, 365);

  var KEY = "age_verified_until";
  var gateEl;

  function nowSec(){ return Math.floor(Date.now()/1000); }
  function daysToSec(d){ return d*24*60*60; }
  function getExpiry(){ try{ return parseInt(localStorage.getItem(KEY)||"0",10);}catch(e){return 0;} }
  function setExpiry(days){ try{ localStorage.setItem(KEY, String(nowSec()+daysToSec(days))); }catch(e){} }
  function isVerified(){ return getExpiry() > nowSec(); }

  function lockScroll(lock){
    document.documentElement.classList.toggle("agegate--locked", lock);
    document.body.classList.toggle("agegate--locked", lock);
  }

  function openGate(){
    if (!gateEl) return;
    gateEl.hidden = false;                   // enlève l'attribut hidden
    requestAnimationFrame(function(){
      gateEl.setAttribute("data-open","true");
    });
    lockScroll(true);

    var yesBtn = document.getElementById("agegate-yes");
    var noBtn  = document.getElementById("agegate-no");

    if (yesBtn){
      yesBtn.addEventListener("click", function(){
        setExpiry(cfg.rememberDays);
        closeGate();
      }, { once:true });
    }

    if (noBtn){
      noBtn.addEventListener("click", function(){
        window.location.href = cfg.underageUrl && cfg.underageUrl !== "https://" ? cfg.underageUrl : "https://www.google.fr";
      });
    }

    setTimeout(function(){ (yesBtn || gateEl).focus(); }, 50);
    // le focus reste dans la fenêtre tant qu'elle est ouverte
    gateEl.addEventListener("keydown", function(e){
      if (e.key !== "Tab") return;
      var f = [yesBtn, noBtn].filter(Boolean);
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    });
  }

  function closeGate(){
    if (!gateEl) return;
    gateEl.removeAttribute("data-open");
    lockScroll(false);
    setTimeout(function(){
      gateEl.hidden = true;                 // évite le focus/tab derrière
    }, 280);
  }

  document.addEventListener("DOMContentLoaded", function(){
    gateEl = document.getElementById("agegate");
    if (!gateEl) return;
    if (!isVerified()) openGate();
  });
})();
